export const useMatchImageWithDescription = (taskAnswer) => {

    const isCorrect = (questionId: string) => {
        if (!taskAnswer) return undefined;
        
        const userAnswer = taskAnswer.userAnswer?.[questionId];
        const correctAnswer = taskAnswer.correctAnswer?.[questionId];
      
        if (userAnswer === undefined || correctAnswer === undefined) {
            return undefined; 
        }
        
        return userAnswer === correctAnswer;
    };

    return {
        isCorrect
    }
}